<template>
  <div>
    <div class="countdown-container" v-if="setting.system_count_down">
      <div class="text">{{!clearTimer ? '本场活动仅剩：' : '本场活动已结束'}}</div>
      <div class="count-down" v-if="!clearTimer">
        <div class="num">{{hour}}</div>
        <div class="letter">时</div>
        <div class="num">{{minute}}</div>
        <div class="letter">分</div>
        <div class="num">{{second}}</div>
        <div class="letter">秒</div>
      </div>
      <!-- {{setting.today_time}} -->
    </div>
  </div>
</template>

<script>
export default {
  name: "CountDown",
  props: {
    setting: Object
  },
  data() {
    return {
      selfSetting: {},
      day: "00",
      hour: "00",
      minute: "00",
      second: "00",
      clearTimer: false // 倒计时是否停止
    };
  },
  watch: {
    setting(val) {
      this.selfSetting = val;
      this.getLastTime();
    }
  },
  components: {},
  mounted() {
    
  },
  methods: {
    // 倒计时
    init() {
      const self = this;
      setTimeout(function() {
        self.getLastTime.call(self);
      }, 1000);
    },
    getLastTime() {
      // console.log(this.selfSetting);

      let time = this.selfSetting.today_time;
      const gapTime = Math.ceil((time - new Date().getTime()) / 1000);
      let day = "00";
      let hour = "00";
      let minute = "00";
      let second = "00";
      if (gapTime > 0) {
        day = this.formatNum(parseInt(gapTime / 86400));
        // let lastTime = gapTime % 86400; // 不需要天
        let lastTime = gapTime;
        hour = this.formatNum(parseInt(lastTime / 3600));
        lastTime = lastTime % 3600;
        minute = this.formatNum(parseInt(lastTime / 60));
        second = this.formatNum(lastTime % 60);
        if (!this.clearTimer) this.init.call(this);
      } else {
        this.endfn();
      }
      this.day = day;
      this.hour = hour;
      this.minute = minute;
      this.second = second;
    },
    // 本场砍价倒计时结束回调
    endfn() {
      this.clearTimer = true;
    },
    // 倒计时时间格式化
    formatNum(num) {
      return num > 9 ? num : `0${num}`;
    }
  }
};
</script>

<style scoped lang="scss">
.countdown-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 0.78rem;
  background: #ffffff;
  color: #222222;
  font-size: 0.24rem;
  .count-down {
    display: flex;
    color: #222222;
    font-size: 0.24rem;
    align-items: center;
    .num {
      width: 0.4rem;
      height: 0.32rem;
      line-height: 0.32rem;
      text-align: center;
      font-size: 0.24rem;
      color: #ffffff;
      background: #111111;
      border-radius: 0.05rem;
    }
    .letter {
      margin: 0 0.1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Bargain/components/Countdown.vue